import { useEffect, useRef } from 'react'
import { DesktopSidebar, type DesktopSidebarProps } from './DesktopSidebar'

interface Props extends Omit<DesktopSidebarProps, 'variant' | 'onClose'> {
  open: boolean
  onClose: () => void
}

export function MobileSidebarDialog({ open, onClose, ...sidebarProps }: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    if (!open && dialog.open) dialog.close()
  }, [open])

  if (!open) return null
  return <dialog ref={dialogRef} className="modal modal-start mobile-sidebar-dialog" aria-label="Workspace navigation" onCancel={event => {
    event.preventDefault()
    onClose()
  }}>
    <div className="modal-box mobile-sidebar-dialog__panel">
      <DesktopSidebar {...sidebarProps} variant="mobile" onClose={onClose}/>
    </div>
    <form method="dialog" className="modal-backdrop"><button type="button" aria-label="Close navigation" onClick={onClose}>close</button></form>
  </dialog>
}
